import axiosInstance from "../../axios/instance";
import { normalizeToUTC } from "@revbox/helpers-fe";
import { getToken } from "../../helpers/get-token";
import { endOfDay, startOfDay } from "date-fns";

async function getPeriodInventoryInsightsRevenue(currentPeriod, previousPeriod, inventoryId) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/analytics/inventory/insights/period/revenue', {
            current_period: [startOfDay(normalizeToUTC(currentPeriod[0])), endOfDay(normalizeToUTC(currentPeriod[1]))],
            previous_period: [startOfDay(normalizeToUTC(previousPeriod[0])), endOfDay(normalizeToUTC(previousPeriod[1]))],
            inventory_id: inventoryId
        })
        return response?.data?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getPeriodInventoryInsightsRevenue;
